import { useContext } from 'react';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import CowcamoLogo from '@/shared/assets/icons/cowcamo-logo.svg?react';
import { getSiteOrigin } from '@/utils/site-origin';

import styles from './index.module.scss';

/**
 * The cowcamo-branded header shown at the top of every experience page.
 *
 * The logo links back to the cowcamo website top (its origin comes from {@link getSiteOrigin},
 * the same cowcamo site used by the error-page recovery), giving users a way home from any dead
 * end besides the back button. When the site origin is unknown it falls back to a plain,
 * non-interactive logo.
 */
const CowcamoHeader = () => {
  const { experienceSettings } = useContext(PageContext);
  const siteOrigin = getSiteOrigin(experienceSettings);

  return (
    <header className={styles.header}>
      {siteOrigin ? (
        <a className={styles.logoLink} href={siteOrigin}>
          <CowcamoLogo className={styles.logo} aria-label="cowcamo" />
        </a>
      ) : (
        <CowcamoLogo className={styles.logo} aria-label="cowcamo" />
      )}
    </header>
  );
};

export default CowcamoHeader;
